var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather01N(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-01n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-01n",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1226,10.2437314 C25.8783832,14.1917137 21.7683446,20.9077467 21.7683446,28.5288762 C21.7683446,39.7393291 30.6614518,48.9913768 42.1588674,50.3555805 C38.4480132,52.7018133 33.9834174,54.0704357 29.1797895,54.0704357 C16.2931453,54.0704357 5.84645614,44.2207002 5.84645614,32.0704357 C5.84645614,19.9201712 16.2931453,10.0704357 29.1797895,10.0704357 C30.1765594,10.0704357 31.1587313,10.1293654 32.1226,10.2437314 Z",
    id: "Combined-Shape",
    stroke: "#373E42",
    fill: "#605F5E",
    strokeLinecap: "square",
    transform: "translate(24.002662, 32.070436) rotate(-13.000000) translate(-24.002662, -32.070436) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,31.5648879 L34.809223,33.7681097 L35.6095902,29.1016109 L32.2191803,25.7967781 L36.9046115,25.1159451 L39,20.8702243 L41.0953885,25.1159451 L45.7808197,25.7967781 L42.3904098,29.1016109 L43.190777,33.7681097 L39,31.5648879 Z",
    id: "Star",
    stroke: "#E3B505",
    fill: "#F5D547",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,13.8148879 L45.7786861,15.2455672 L46.2984108,12.2153397 L44.0968216,10.0693206 L47.1393431,9.62721638 L48.5,6.87022427 L49.8606569,9.62721638 L52.9031784,10.0693206 L50.7015892,12.2153397 L51.2213139,15.2455672 L48.5,13.8148879 Z",
    id: "Star-Copy",
    stroke: "#E3B505",
    fill: "#F5D547",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather01N);
export default __webpack_public_path__ + "static/media/icon-weather-01n.b675ee43596c557b781b87ba5d16aaa5.svg";
export { ForwardRef as ReactComponent };